import { inject } from '@angular/core';
import {
  HttpInterceptorFn,
  HttpErrorResponse
} from '@angular/common/http';
import { catchError, throwError } from 'rxjs';
import { AuthService } from '../services/auth.service';
import { ToastService } from '../../services/toast.service';


function currentLang(): 'en' | 'es' | 'fr' {
  const stored = (localStorage.getItem('bluedop_language') || '').toLowerCase();
  if (stored.startsWith('es')) return 'es';
  if (stored.startsWith('fr')) return 'fr';
  return 'en';
}

function permissionDeniedText(): string {
  const lang = currentLang();
  if (lang === 'es') return 'No tienes permiso para realizar esta accion.';
  if (lang === 'fr') return "Vous n'avez pas la permission d'effectuer cette action.";
  return "You don't have permission to perform this action.";
}

export const AuthInterceptor: HttpInterceptorFn = (req, next) => {
  const auth = inject(AuthService);
  const toast = inject(ToastService);

  const token = auth.accessToken();

  if (!token) {
    return next(req);
  }

  const authReq = req.clone({
    setHeaders: {
      Authorization: `Bearer ${token}`
    }
  });

  return next(authReq).pipe(
    catchError((err: HttpErrorResponse) => {
      if (err.status === 401) {
        auth.triggerSessionExpiry();
      }
      if (err.status === 403) {
        toast.warning(permissionDeniedText());
        return throwError(() => err);
      }
      return throwError(() => err);
    })
  );
};
